import { render, staticRenderFns } from "./ClinicInfo.vue?vue&type=template&id=1833f584&scoped=true"
import script from "./ClinicInfo.vue?vue&type=script&lang=js"
export * from "./ClinicInfo.vue?vue&type=script&lang=js"
import style0 from "./ClinicInfo.vue?vue&type=style&index=0&id=1833f584&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1833f584",
  null
  
)

export default component.exports